import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';

// This is done
const PrivacyPolicyHeader = () => {
  return (
    <PrivacyPolicyContainer>
      <p>Last Updated: May 14, 2025</p>
      <p>
        Welcome to the Privacy Policy of Yoda Safety Services. This Privacy
        Policy explains how we collect, use, and share your personal information
        when you interact with our platform, including but not limited to:
      </p>
      <ul>
        <li>Our training portal, courses, and quizzes.</li>
        <li>Newsletters and promotional communications.</li>
        <li>Payments made through PayPal or other payment processors.</li>
        <li>User and company account management.</li>
      </ul>
      <p>
        By using our platform, you agree to the practices described in this
        Privacy Policy. For more details, please review the full policy below.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default PrivacyPolicyHeader;
